module.exports = __webpack_public_path__ + "img/icn_close.a6f8d49e.svg";